import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Card, CardDeck} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import {openReportsCount} from '../../store/reports/selectors';
import departmentSettingsSelectors from "../../store/department-settings/selectors";

const MgtMetricTiles = (props) => {
  return (
    <Fragment>
      <CardDeck>
        {props.activeOits !== null && (
          <Card body style={{ borderColor: '#5d9de4' }}>
            <NavLink to="/oits">
              <div className="card-header">
                <i
                  className="fa fa-user-circle"
                  style={{ color: '#5d9de4' }}
                />
                <div>
                  {props.activeOits}
                  <span> Active {props.oitShortLabel}&apos;s</span>
                </div>
              </div>
            </NavLink>
          </Card>
        )}

        {props.activeFtos !== null && (
          <Card body style={{ borderColor: '#333' }}>
            <NavLink to="/active-ftos">
              <div className="card-header">
                <i className="fa fa-id-badge" style={{ color: '#333' }} />
                <div>
                  {props.activeFtos}
                  <span> Active {props.ftoShortLabel}</span>
                </div>
              </div>
            </NavLink>
          </Card>
        )}

        {props.outstandingForms !== null && (
          <Card body style={{ borderColor: '#7b111d' }}>
            <div className="card-header">
              <i className="fa fa-file" style={{ color: '#7b111d' }} />
              <div>
                {props.outstandingForms}
                <span> Outstanding Forms</span>
              </div>
            </div>
          </Card>
        )}
        {props.oitsRemedials !== null && (
          <Card body style={{ borderColor: '#7b451d' }}>
            <div className="card-header">
              <i className="fa fa-flag" style={{ color: '#7b451d' }} />
              <div>
                {props.oitsRemedials}
                <span> {props.oitShortLabel}&apos;s in Remedial Program </span>
              </div>
            </div>
          </Card>
        )}

        {props.dor !== null && (
          <Card body style={{ borderColor: '#282b7b' }}>
            <div className="card-header">
              <i className="fa fa-file-text" style={{ color: '#282b7b' }} />
              <div>
                {props.dor}
                <span> DOR</span>
              </div>
            </div>
          </Card>
        )}

        {props.wor !== null && (
          <Card body style={{ borderColor: '#5e4037' }}>
            <div className="card-header">
              <i className="fa fa-file-text" style={{ color: '#5e4037' }} />
              <div>
                {props.wor}
                <span> WOR</span>
              </div>
            </div>
          </Card>
        )}

        {props.assignedOits !== null && (
          <Card style={{ borderColor: '#5d9de4' }}>
            <NavLink to="/my-oits">
              <div className="card-header">
                <i
                  className="fa fa-user-circle"
                  style={{ color: '#5d9de4' }}
                />
                <span>{props.assignedOits} Assigned {props.oitShortLabel}</span>
              </div>
            </NavLink>
          </Card>
        )}

        {props.openReportsCount !== null && (
          <Card body style={{ borderColor: '#7b111d' }}>
            <div className="card-header">
              <i
                className="fa fa-exclamation-circle"
                style={{ color: '#7b111d' }}
              />
              <span>{props.openReportsCount} My Open Forms</span>
            </div>
          </Card>
        )}

        {props.openReportsCount !== null && (
          <Card body style={{ borderColor: '#7b111d' }}>
            <div className="card-header">
              <i className="fa fa-file" style={{ color: '#7b111d' }} />
              <span>{props.openReportsCount} {props.oitShortLabel} Open Forms </span>
            </div>
          </Card>
        )}
        {props.riskAlerts !== null && (
          <Card body style={{ borderColor: '#e4b95d' }}>
            <div className="card-header">
              <i className="fa fa-warning" style={{ color: '#e4b95d' }} />
              <span> {props.riskAlerts} Current 7-day Risk Alerts</span>
            </div>
          </Card>
        )}
      </CardDeck>
    </Fragment>
  );
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    dor: state.dashboard.dor,
    wor: state.dashboard.wor,
    activeFtos: state.dashboard.activeFtos,
    activeOits: state.dashboard.activeOits,
    oitsRemedials: state.dashboard.oitsRemedials,
    outstandingForms: state.dashboard.outstandingForms,
    openReportsCount: openReportsCount(state),
    assignedOits: state.dashboard.assignedOits,
    riskAlerts: state.dashboard.riskAlerts,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  };
};

export default connect(mapStateToProps, null)(MgtMetricTiles);
